export enum ModuleStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  MAINTENANCE = 'maintenance'
}

export interface Module {
  id: string;
  name: string;
  slug: string;
  description?: string;
  icon?: string;
  color?: string;
  version?: string;
  status: ModuleStatus;
  features?: string[];
  permissions?: {
    read: string[];
    write: string[];
    admin: string[];
  };
  configuration?: Record<string, any>;
  sortOrder: number;
  isCore: boolean;
  type?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateModuleRequest {
  name: string;
  slug: string;
  description?: string;
  icon?: string;
  color?: string;
  version?: string;
  status?: ModuleStatus;
  features?: string[];
  permissions?: {
    read: string[];
    write: string[];
    admin: string[];
  };
  configuration?: Record<string, any>;
  sortOrder?: number;
  isCore?: boolean;
  type?: string;
}

export interface UpdateModuleRequest {
  name?: string;
  slug?: string;
  description?: string;
  icon?: string;
  color?: string;
  version?: string;
  status?: ModuleStatus;
  features?: string[];
  permissions?: {
    read: string[];
    write: string[];
    admin: string[];
  };
  configuration?: Record<string, any>;
  sortOrder?: number;
  isCore?: boolean;
  type?: string;
}

export interface AssignModuleToTenantRequest {
  moduleId: string;
  isActive?: boolean;
  configuration?: Record<string, any>;
  permissions?: {
    read: string[];
    write: string[];
    admin: string[];
  };
}

export interface TenantModule {
  id: string;
  tenantId: string;
  moduleId: string;
  isActive: boolean;
  configuration?: Record<string, any>;
  permissions?: {
    read: string[];
    write: string[];
    admin: string[];
  };
  module: Module;
  createdAt: Date;
  updatedAt: Date;
}
